// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hyphen-form-builder-type-dash[data-v-8b432f94]{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
